import React, { useEffect, useState } from "react";
import Toolbar from "../../navigation/mobile/Toolbar";
import UniversalBack from "../../common/mobile/UniversalBack";

function ResetPassword({ showAlert }) {

	const [data, setData] = useState({
		old_password: "",
		new_password: "",
		new_password_confirmation: "",
	});

	const [passwordShown, setPasswordShown] = useState({
		old_password: false,
		new_password: false,
		new_password_confirmation: false,
	});

	const [error, setError] = useState("");
	const [token, setToken] = useState(localStorage.getItem("token"));
	useEffect(() => {
		setToken(localStorage.getItem("token"));
	}, []);
	

	const togglePasswordVisibility = (name) => {
		let data = {...passwordShown};
		data[name] = !data[name];
		setPasswordShown(data);
	};

	const updatePassword = () => {

		if(!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(data.new_password)) {
			setError("New Password must contain at least one number, one letter, and 8 characters long.");
			return;
		}
		if(!data.old_password) {
			setError("Please enter your current password.");
			return;
		}
		if(!data.new_password_confirmation) {
			setError("Please confirm your new password.");
			return;
		}
		if(data.new_password !== data.new_password_confirmation) {
			setError("Passwords do not match.");
			return;
		}

		setError("");
		fetch(`${process.env.REACT_APP_API_URL}/api/user-pwd`, {
			method: "POST",
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		}).then(response => {
			if (!response.ok) {
				return response.json().then(errData => {
					const errMsg = errData?.message || "Failed to change password. Please try again.";
					throw new Error(errMsg);
				});
			}
			return response.json();
		}).then(data => {
			showAlert("Password changed successfully. Please login with your new password.", 'success');
			setTimeout(() => {
				window.location.href = "/login";
			}, 1500);
		}).catch(error => {
			console.error("Error:", error);
			setError(error?.message || "An error occurred while changing the password. Please try again.");
		});
	};

    return (
        <div className="main-router-wrapper">
            <header id="header" className="login player">
                <div className="header-left-btn-group">
                   <UniversalBack/>
                    
                </div>
                <div className="header-title">Reset password</div>
                <div
                    className="logo"
                    tabIndex={0}
                    style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/logo.png?v=1729676340443")' }}
                />
                <div className="header-right-btn-group">
                    <a name="helpCenter" className="service-btn">
                        <span
                            className="item-icon"
                            style={{
                                maskImage:
                                    'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/index-theme-icon/header-service-icon.svg?v=1729676340443")',
                            }}
                        />
                        <p>Help</p>
                    </a>
                </div>
            </header>

            <div className="wrap">
                <div className="content member-content">
					<div className="member-box radius">
						<div className="error-message" style={{ color: 'red', fontSize: '16px', marginTop: '10px', textAlign: 'center' }}>
							{error && <span>{error}</span>}
						</div>
                        <form noValidate className="ng-untouched ng-pristine ng-invalid">
                            {/* Current Password */}
                            <div className="inputbox password">
								<div
									className={`eyes ${passwordShown?.old_password ? 'active' : ''}`}
									onClick={() => togglePasswordVisibility('old_password')}
								/>
                                <label style={{ display: 'block' }}>Current password</label>
								<input className="input" type={ passwordShown?.old_password===true ? 'text' : 'password'} placeholder="Current password" onChange={(e) => {
									setData({ ...data, old_password: e.target.value });
								}} />
                                <input className="clear" />
                            </div>

                            {/* New Password */}
                            <div className="inputbox password">
                                <div
									className={`eyes ${passwordShown?.new_password ? 'active' : ''}`}
									onClick={() => togglePasswordVisibility('new_password')}
								/>
                                <label style={{ display: 'block' }}>New password</label>
                                <input className="input" type={ passwordShown?.new_password===true ? 'text' : 'password'} placeholder="New password"  onChange={(e) => {
									setData({ ...data, new_password: e.target.value });
								}} />
                                <input className="clear" />
                            </div>

                            {/* Confirm New Password */}
                            <div className="inputbox password">
                                <div
									className={`eyes ${passwordShown?.new_password_confirmation ? 'active' : ''}`}
									onClick={() => togglePasswordVisibility('new_password_confirmation')}
								/>
                                <label style={{ display: 'block' }}>Confirm new password</label>
                                <input className="input" type={ passwordShown?.new_password_confirmation===true ? 'text' : 'password'} placeholder="Confirm new password" onChange={(e) => {
									setData({ ...data, new_password_confirmation: e.target.value });
								}} />
                                <input className="clear" />
                            </div>

                            {/* Password Requirements */}
                            <div className="tips-info">
                                <div className="title-box">
                                    <h5>
                                        <span>Password requirements</span>
                                    </h5>
                                </div>
                                <ol>
                                    <li>Must be between 6 to 20 characters.</li>
                                    <li>Must contain 1 uppercase alphabet(A-Z) at least</li>
                                    <li>Must contain 1 lowercase alphabet(a-z) at least</li>
                                    <li>Must contain at least 1 number (0-9).</li>
                                    <li>Must contain special characters (@$%¨!%*#).</li>
                                </ol>
                            </div>

                            {/* Confirm Button */}
                            <div className="button submit">
                                <a href="javascript:{};" onClick={updatePassword}>Change password</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Toolbar />
        </div>
    );
}

export default ResetPassword;
